import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// 数据收集
interface CollectJson {
  series?: number;
}
export const collect = (json: CollectJson): any =>
  http.httpPost({
    url: httpApi.collection.collect,
    json,
  });
// 数据收集
interface CollectJson {
  series?: number;
}
export const competitionCollect = (json: CollectJson): any =>
  http.httpPost({
    url: httpApi.collection.competitionCollect,
    json,
  });

// 盒子新统一埋点
interface BoxCollectJson {
  id: string;
}
export const boxCollect = (json: BoxCollectJson): any =>
  http.httpPost({
    url: httpApi.collection.boxCollect,
    json,
  });
